// Suffix words that vary across listings for the same developer
// (e.g. "Wadan Developments" vs "Wadan"). Stripped from the tail before
// lower-casing into a stable lookup key.
const NOISE_SUFFIXES = [
  'developments',
  'development',
  'developers',
  'developer',
  'properties',
  'property',
  'real estate',
  'group',
  'holding',
  'holdings',
];

/**
 * Stable lookup key for matching the same developer across data sources
 * (Geniemap `property.developer.en` vs availability_bot `developers.name`).
 *
 * Pipeline: trim → collapse whitespace → strip one trailing noise suffix →
 * lowercase → squash non-alphanumerics to single dashes → trim dashes.
 *
 * Examples: "Ellington Properties" → "ellington",
 *           "Wadan Developments"   → "wadan",
 *           "DAMAC"                → "damac".
 */
export function normalizeDeveloperName(raw: string): string {
  if (!raw) return '';

  let value = raw.trim().replace(/\s+/g, ' ');
  const lower = value.toLowerCase();

  for (const suffix of NOISE_SUFFIXES) {
    if (lower.endsWith(` ${suffix}`)) {
      value = value.slice(0, -1 - suffix.length).trim();
      break;
    }
  }

  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}
